export default function isEqualArrays(a: any[], b: any[]) {
    return a.toString() === b.toString()
}